/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { upoGetUpoPdfFromGoAml } from '../fn/upo/upo-get-upo-pdf-from-go-aml';
import { UpoGetUpoPdfFromGoAml$Params } from '../fn/upo/upo-get-upo-pdf-from-go-aml';
import { upoGetUpoPdfFromSigiif } from '../fn/upo/upo-get-upo-pdf-from-sigiif';
import { UpoGetUpoPdfFromSigiif$Params } from '../fn/upo/upo-get-upo-pdf-from-sigiif';
import { upoGetUpoXmlFromGoAml } from '../fn/upo/upo-get-upo-xml-from-go-aml';
import { UpoGetUpoXmlFromGoAml$Params } from '../fn/upo/upo-get-upo-xml-from-go-aml';
import { upoGetUpoXmlFromSigiif } from '../fn/upo/upo-get-upo-xml-from-sigiif';
import { UpoGetUpoXmlFromSigiif$Params } from '../fn/upo/upo-get-upo-xml-from-sigiif';

@Injectable({ providedIn: 'root' })
export class UpoService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `upoGetUpoPdfFromGoAml()` */
  static readonly UpoGetUpoPdfFromGoAmlPath = '/upo/goaml/{id}/pdf';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `upoGetUpoPdfFromGoAml()` instead.
   *
   * This method doesn't expect any request body.
   */
  upoGetUpoPdfFromGoAml$Response(params: UpoGetUpoPdfFromGoAml$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return upoGetUpoPdfFromGoAml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `upoGetUpoPdfFromGoAml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  upoGetUpoPdfFromGoAml(params: UpoGetUpoPdfFromGoAml$Params, context?: HttpContext): Observable<void> {
    return this.upoGetUpoPdfFromGoAml$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `upoGetUpoXmlFromGoAml()` */
  static readonly UpoGetUpoXmlFromGoAmlPath = '/upo/goaml/{id}/xml';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `upoGetUpoXmlFromGoAml()` instead.
   *
   * This method doesn't expect any request body.
   */
  upoGetUpoXmlFromGoAml$Response(params: UpoGetUpoXmlFromGoAml$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return upoGetUpoXmlFromGoAml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `upoGetUpoXmlFromGoAml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  upoGetUpoXmlFromGoAml(params: UpoGetUpoXmlFromGoAml$Params, context?: HttpContext): Observable<void> {
    return this.upoGetUpoXmlFromGoAml$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `upoGetUpoPdfFromSigiif()` */
  static readonly UpoGetUpoPdfFromSigiifPath = '/upo/sigiif/{id}/pdf';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `upoGetUpoPdfFromSigiif()` instead.
   *
   * This method doesn't expect any request body.
   */
  upoGetUpoPdfFromSigiif$Response(params: UpoGetUpoPdfFromSigiif$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return upoGetUpoPdfFromSigiif(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `upoGetUpoPdfFromSigiif$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  upoGetUpoPdfFromSigiif(params: UpoGetUpoPdfFromSigiif$Params, context?: HttpContext): Observable<void> {
    return this.upoGetUpoPdfFromSigiif$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `upoGetUpoXmlFromSigiif()` */
  static readonly UpoGetUpoXmlFromSigiifPath = '/upo/sigiif/{id}/xml';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `upoGetUpoXmlFromSigiif()` instead.
   *
   * This method doesn't expect any request body.
   */
  upoGetUpoXmlFromSigiif$Response(params: UpoGetUpoXmlFromSigiif$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return upoGetUpoXmlFromSigiif(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `upoGetUpoXmlFromSigiif$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  upoGetUpoXmlFromSigiif(params: UpoGetUpoXmlFromSigiif$Params, context?: HttpContext): Observable<void> {
    return this.upoGetUpoXmlFromSigiif$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
